// extracted by mini-css-extract-plugin
export default {"input":"textarea_input__RV+Gq","error-input":"textarea_error-input__z0lFY"};